import React from 'react'
import { MarkerView } from './MarkerView'

export const Marker = ({
  color,
  size = 12,
  style = {}
}: {
  color?: string | ''
  size?: number
  style?: object
}): JSX.Element => {
  return (
    <MarkerView
      color={color}
      size={size}
      style={style}
    ></MarkerView>
  )
}
